import React, { PureComponent } from 'react';

import Icon from 'components/icon';
import { subscribe, unsubscribe } from 'util/misc/overlay-tracker';
import InputField from 'components/form/form-field-input';
import PropTypes from 'prop-types';
import SearchPanel from './search-panel';
import SearchPanelMobile from './search-panel-mobile';
import classnames from 'classnames';
import Aria51 from 'components/aria-51';
import { connect } from 'react-redux';
import reduxUtils from 'util/redux';
import { t } from 'translations';
import preventDefault from 'util/dom/prevent-default';


class Search extends PureComponent {
    static propTypes = {
        closeSearch: PropTypes.func.isRequired,
        isActive: PropTypes.bool.isRequired,
        isMobile: PropTypes.bool.isRequired,
        isScrollLocked: PropTypes.bool.isRequired,
        lockScroll: PropTypes.func.isRequired,
        openSearch: PropTypes.func.isRequired,
        populateCommonCategories: PropTypes.func.isRequired,
        reset: PropTypes.func.isRequired,
        activeRegion: PropTypes.object,
        search: PropTypes.func.isRequired,
        commonCategories: PropTypes.array.isRequired,
        setLimit: PropTypes.func.isRequired,
        setOffset: PropTypes.func.isRequired,
        unlockScroll: PropTypes.func.isRequired,
        setFuzzy: PropTypes.func.isRequired,
        persistTerm: PropTypes.func.isRequired,
        term: PropTypes.string.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            term: props.term,
        };
    }

    /*
    * LifeCycle
    */
    componentWillReceiveProps({ isScrollLocked, isActive, commonCategories, activeRegion, term }) {
        this.setState({ term });

        if (this.props.isScrollLocked && !isScrollLocked) {
            this.deactivateSearch();
        }

        if (isActive && !this.state.hasTerm && !commonCategories.length || this.props.activeRegion && activeRegion.cooperative !== this.props.activeRegion.cooperative) {
            this.props.populateCommonCategories();
        }
    }

    onClearAction = () => {
        this.props.reset();
        this.setState({ term: '' });
    };

    onFocus = () => {
        this.activateSearch();
    };

    onBlur = () => {
        if (!this.state.term) {
            this.deactivateSearch();
        }
    };

    onSubmit = (e) => {
        preventDefault(e);
        const { search } = this.props;
        const { term } = this.state;

        this.props.setFuzzy({ isFuzzy: false });
        search({ term, isEnterPressed: true });
    };

    onInput = value => {
        if (!this.props.isActive) {
            this.activateSearch();
        }

        this.props.setFuzzy({ isFuzzy: true });

        if (value !== this.state.term) {
            this.props.setOffset({ offset: 0 });
        }

        const term = value;
        this.setState({ term });
        const { reset, setLimit, search } = this.props;

        // if user clears input with backspace action, clear results
        if (term.length <= 0) {
            reset();
        } else {
            setLimit({ limit: 20 });
            search({ term });
        }

        this.props.persistTerm({ term });
    };

    activateSearch = () => {
        subscribe(this, this.closePanel);
        this.props.openSearch();
        this.props.lockScroll();
    };

    deactivateSearch = () => {
        const { closeSearch, unlockScroll, reset } = this.props;
        closeSearch();
        unlockScroll();
        reset();
        this.setState({ term: '' });
        this.props.persistTerm({ term: '' });
    };

    blurElement() {
        const el = document.activeElement;

        if (el) {
            el.blur();
        }
    }

    closePanel = () => {
        unsubscribe(this);
        this.props.closeSearch();
        this.props.unlockScroll();
        this.setState({ term: '' });
        this.blurElement();
    };

    render() {
        const { isActive, isMobile } = this.props;
        const { term, hasTerm } = this.state;
        if (isMobile) {
            return (
                <Aria51 isActive={isActive} className="main-header--search-button-container">
                    <button className="main-header--search-button" onClick={() => this.activateSearch()}>
                        <Icon size="medium" symbol="search"/>
                    </button>
                    <SearchPanelMobile isActive={isActive && isMobile}/>
                </Aria51>
            );
        }

        return (
            <Aria51
                isActive={isActive}
                className={classnames('search', {
                    'search__is-active': isActive,
                })}
            >

                <form role="search" onSubmit={this.onSubmit}>
                    <InputField
                        aria-label={t('search.search')}
                        placeholder={t('search.placeholder')}
                        actionLabel={t('search.search')}
                        hasClearAction={this.onClearAction}
                        className='main-header--search-field'
                        type="search"
                        value={term}
                        onInput={this.onInput}
                        onFocus={this.onFocus}
                        icon={{ size: 'medium', symbol: 'search' }}
                        variant={'search'}
                    />
                </form>
                <div className="search--results">
                    <SearchPanel hasTerm={hasTerm}/>
                </div>
            </Aria51>
        );
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        isActive: 'search.isActive',
        isMobile: 'viewport.isMobile',
        isScrollLocked: 'scroll.isLocked',
        activeRegion: 'region.active',
        commonCategories: 'search.commonCategories',
        rotationPersistedTerm: 'search.rotationPersistedTerm',
        term: 'search.term',
    }),
    reduxUtils.mapDispatchToProps({
        closeSearch: 'search.close',
        lockScroll: 'scroll.lock',
        openSearch: 'search.open',
        populateCommonCategories: 'search.populateCommonCategories',
        reset: 'search.reset',
        search: 'search.query',
        setLimit: 'search.setLimit',
        setOffset: 'search.setOffset',
        setFuzzy: 'search.setFuzzy',
        unlockScroll: 'scroll.unlock',
        persistTerm: 'search.persistTerm',
    }),
)(Search);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/main-header/search/index.js